import React, { useState } from 'react';
import ApplicationHeading from '@/components/Elements/Heading/ApplicationHeading';
import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';
import { Button, Card, Col, Row, Space, Table, Tag, Typography } from 'antd';
import { CheckOutlined, CloseOutlined, RightOutlined } from '@ant-design/icons';
import TableTitle from '@/components/Elements/Heading/TableTitle';
import { formatDate } from '@/utils/commonUtils';
import HubSpotForm from '@/components/HubspotForm/BuyersAgentHubspotForm';

const EngagementsPage = () => {
  const [dealStageFilter, setDealStageFilter] = useState<string | null>(null);

  const columns: any = [
    {
      title: <TableTitle>S.N</TableTitle>,
      key: 'index',
      align: 'center',
      render: (_: any, __: any, index: number) => (
        <Typography.Text strong>{index + 1}</Typography.Text>
      ),
      width: 100,
    },
  ];

  return (
    <div style={{ width: '100%', marginTop: '20px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={24}>
          <Card
            title="Active Engagements"
            extra={
              dealStageFilter && (
                <Tag
                  closable
                  onClose={() => {
                    setDealStageFilter(null);
                  }}
                >
                  {dealStageFilter}
                </Tag>
              )
            }
          >
            <Table
              bordered
              columns={columns}
              rowKey="id"
              pagination={{ pageSize: 5 }}
              scroll={{
                x: 'max-content',
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EngagementsPage;
